import {gql} from "apollo-boost";

export const EmployeeQuery = gql`
    query Employee($documentType: Int!, $documentNumber: String!){
        employeeFunCol(documentType:$documentType, documentNumber:$documentNumber){
            institutionId
            scheduleId
            documentType
            documentNumber
            name
            lastName
        }
    }
`;

